import { Component, OnInit } from '@angular/core';

const NAVLINKS = [
  {title: 'Regler for brøkregning', link:'/fractions-intro', content:'Læs lidt om reglerne for at regne med brøker.'},
  {title: 'Forkort/forlæng brøker', link:'/fractions-extend', content:'Når du skal regne med brøker, har du ofte brug for at forlænge eller forkorte brøker'},
  {title: 'Brøker of decimal tal', link:'/fractions-numbers', content:'Nogle brøker kan skrives som et decimal tal, andre vil blot blive en uendelig talrække. Lær mere her.'},
  {title: 'Plus med brøker', link:'/fractions-add', content:'Øv dig på at lægge brøker sammen.'},
  {title: 'Minus med brøker', link:'/fractions-minus', content:'Øv dig på at trække brøker fra hinanden.'},
  {title: 'Gange med brøker', link:'/fractions-multiply', content:'Øv dig på at gange med brøker.'},
  {title: 'Dividere med brøker', link:'/fractions-division', content:'Øv dig på at dividere med brøker.'},
];

@Component({
  selector: 'app-menu-fractions',
  templateUrl: './menu-fractions.component.html',
  styleUrls: ['./menu-fractions.component.css']
})
export class MenuFractionsComponent implements OnInit {

  navLinks = NAVLINKS;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/menu-fractions/menu-fractions.component.ts